<app-kpi-widget 
  [title]="'driverDashboard.widgets.driversInVehicle' | transloco" 
  [isLoading]="isLoading" 
  [icon]="'ph-truck'" 
  [totalValue]="value"
  [valueFormatter]="formatValue"
  [hasError]="hasError" 
  [errorMessage]="errorMessage" 
  (clicked)="openDriverInVehicleModal()"
  [widgetDisabled]="false"
  [dropdownEnabled]="false"
  [isImageIcon]="false"
  [hasFooter]="false"
  [percentageDifferenceEnabled]="false"
  [hasValueOnly]="true"
  [widgetDisabled]="false">
</app-kpi-widget>